Math.easeInOutQuad = function (t, b, c, d) {
  t /= d / 2
  if (t < 1) {
    return (c / 2) * t * t + b
  }
  t--
  return (-c / 2) * (t * (t - 2) - 1) + b
}

export const requestAnimFrame =
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  function (callback) {
    window.setTimeout(callback, 1000 / 60)
  }

export const closeRequestAnimFrame = timer => {
  window.requestAnimationFrame && window.cancelAnimationFrame && window.cancelAnimationFrame(timer)
  window.clearTimeout(timer)
}

function move(element, amount) {
  if (element) {
    element.scrollTop = amount
  } else {
    document.documentElement.scrollTop = amount
    document.body.parentNode.scrollTop = amount
    document.body.scrollTop = amount
  }
}

function position(element) {
  if (element) {
    return element.scrollTop
  }
  return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop
}

export function scrollTo(element, to, duration, callback) {
  const start = position(element)
  const change = to - start
  const increment = 10
  let currentTime = 0
  let timer
  duration = typeof duration === 'undefined' ? 500 : duration
  var animateScroll = function () {
    currentTime += increment
    var val = Math.easeInOutQuad(currentTime, start, change, duration)
    move(element, val)
    if (currentTime < duration) {
      timer = requestAnimFrame.call(window, animateScroll)
    } else {
      closeRequestAnimFrame(timer)
      if (callback && typeof callback === 'function') {
        callback()
      }
    }
  }
  animateScroll()
}
